import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import Address from '../../../../classes/Address';
import PhoneIcon from '../../ui/svg/Components/PhoneIcon';
import useStyles from './AddressAsText.styles';

export default function AddressAsText(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const address = new Address(props);
  const name = props.addressee || `${props.firstName} ${props.lastName}`;
  
  return (
    <div data-test="AddressAsText" className={classes.addressAsText} data-cs-mask>
      <p className={classes.fullName}>
        {props.addressNickname ? props.addressNickname : name}
      </p>
      {address.getAddressString()}
      {props.contactNumber && (
        <span className={classes.contactNumber} data-test="AddressAsText__contactNumber">
          <PhoneIcon className={classes.phoneIcon} />
          {props.contactNumber}
        </span>
      )}
    </div>
  );
}

AddressAsText.propTypes = {
  addressId: PropTypes.string,
  addressee: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  nameNumber: PropTypes.string,
  streetName: PropTypes.string,
  addressLine2: PropTypes.string,
  townCity: PropTypes.string,
  county: PropTypes.string,
  postCode: PropTypes.string,
  countryName: PropTypes.string,
  addressNickname: PropTypes.string,
  contactNumber: PropTypes.string,
  inEditDeleteExperiment: PropTypes.bool,
};
